const isFunction = function(functionToCheck) {
	return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';
};

export const windowResizeAxisX = function(callback) {
	if (isFunction(callback)) {
		var resizeId;
		var oldWidth = window.innerWidth;

		window.addEventListener('resize', function() {
			clearTimeout(resizeId);
			resizeId = setTimeout(function() {
				if (oldWidth != window.innerWidth) { // проверяем что ресайз сделан горизонтально а не вертикально
					callback();
					
					oldWidth = window.innerWidth;
				}
			}, 200);
		});
	}
};